import { FC } from 'react';
import { DashboardSidebarSubNavigation } from '@cbridge-modules/sidebar';
import { RouteSegments, useSettingsNavigationItems } from '@cbridge-packages/routing-client-admin';

export const SettingsNavigation: FC = () => {
  const settingsNavigation = useSettingsNavigationItems();

  return (
    <DashboardSidebarSubNavigation
      items={settingsNavigation}
      variant={'secondary'}
      basePath={`/${RouteSegments.Root.Config}`}
      isMini={false}
      isFullyExpanded={true}
    />

  );
};
